import React, { useEffect, useRef, useState, useCallback } from 'react';
import './GoogleMapDisplay.css'; // Import the CSS

// IMPORTANT: Replace with your actual API key or manage it securely
const GOOGLE_MAPS_API_KEY = 'AIzaSyC19JvSSEcutiA5Ekz0FtfSDp6_2u0Wwtk'; 


const GoogleMapDisplay = ({ locations, mapContainerStyle }) => {
  console.log("map locations : " , locations)
  const mapRef = useRef(null); // To hold the div element for the map
  const [isScriptLoaded, setIsScriptLoaded] = useState(!!window.google);
  const infoWindowRef = useRef(null);
  const currentlySelectedMarkerDivRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markersRef = useRef([]); // To keep track of markers for cleanup

  useEffect(() => {
    if (!isScriptLoaded) {
      const existingScript = document.querySelector(`script[src*="maps.googleapis.com"]`);
      if (existingScript) {
        if (window.google) {
            setIsScriptLoaded(true);
        } else {
            existingScript.addEventListener('load', () => {
              setIsScriptLoaded(true);
            });
        }
        return;
      }

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        setIsScriptLoaded(true);
      };
      script.onerror = () => {
        console.error("Google Maps script failed to load.");
      };
      document.head.appendChild(script);

      return () => {
        // Clean up script if this component unmounts before script loads
        // However, Google Maps script once loaded stays loaded.
        // More complex cleanup might be needed if multiple map components load/unload scripts.
      };
    }
  }, [isScriptLoaded]);

  const initMap = useCallback(() => {
    if (!isScriptLoaded || !locations || locations.length === 0 || !mapRef.current || !window.google) {
      return;
    }

    // Clear previous markers
    markersRef.current.forEach(marker => {
      if (marker.setMap) marker.setMap(null); // For google.maps.Marker
      else if (marker.onRemove) marker.onRemove(); // For OverlayView
    });
    markersRef.current = [];

    const mapDiv = mapRef.current;

    if (!infoWindowRef.current) {
      infoWindowRef.current = new window.google.maps.InfoWindow({
        maxWidth: 300,
        pixelOffset: new window.google.maps.Size(0, -50)
      });
    }

    window.google.maps.event.clearListeners(infoWindowRef.current, 'closeclick');
    window.google.maps.event.addListener(infoWindowRef.current, 'closeclick', () => {
      if (currentlySelectedMarkerDivRef.current) {
        currentlySelectedMarkerDivRef.current.classList.remove('clicked');
        currentlySelectedMarkerDivRef.current = null;
      }
    });

    class CustomMarkerOverlay extends window.google.maps.OverlayView {
      constructor(position, locationData, mapInstance) {
        super();
        this.position = position;
        this.locationData = locationData;
        this.mapInstance = mapInstance;
        this.div = null;
        this.setMap(mapInstance); // This will call onAdd
      }

      onAdd() {
        this.div = document.createElement('div');
        this.div.className = 'custom-map-marker';
        if (this.locationData.full_path) {
            this.div.style.backgroundImage = `url(${this.locationData.full_path})`;
        }
        // Add other default styles or content if full_path is not available

        const panes = this.getPanes();
        panes.overlayMouseTarget.appendChild(this.div);

        this.div.addEventListener('click', () => {
          if (currentlySelectedMarkerDivRef.current && currentlySelectedMarkerDivRef.current !== this.div) {
            currentlySelectedMarkerDivRef.current.classList.remove('clicked');
          }
          this.div.classList.add('clicked');
          currentlySelectedMarkerDivRef.current = this.div;

          const contentString = `
            <div style="max-width: 250px; text-align: center;">
              <h5>Localisation ${this.locationData.originalIndex + 1}</h5> 
              ${this.locationData.full_path ? `<img src="${this.locationData.full_path}" style="width: 100%; max-height: 180px; object-fit: cover; border-radius: 10px; margin-bottom: 12px;">` : '<p class="text-muted">No image available</p>'}
              <p style="margin-bottom: 5px;">${this.locationData.latitude}, ${this.locationData.longitude}</p>
            </div>
          `;
          infoWindowRef.current.setContent(contentString);
          infoWindowRef.current.setPosition(this.position);
          infoWindowRef.current.open(this.mapInstance);
        });
      }

      draw() {
        const overlayProjection = this.getProjection();
        if (!overlayProjection || !this.div) return;
        const sw = overlayProjection.fromLatLngToDivPixel(this.position);
        this.div.style.left = sw.x + 'px';
        this.div.style.top = sw.y + 'px';
      }

      onRemove() {
        if (this.div && this.div.parentNode) {
          this.div.parentNode.removeChild(this.div);
          this.div = null;
        }
      }
       hide() { if (this.div) { this.div.style.display = 'none'; } }
       show() { if (this.div) { this.div.style.display = 'block'; } }
    }

    try {
      const bounds = new window.google.maps.LatLngBounds();
      locations.forEach((loc) => {
        if (loc.latitude && loc.longitude) {
          bounds.extend(
            new window.google.maps.LatLng(parseFloat(loc.latitude), parseFloat(loc.longitude))
          );
        }
      });
      
      if (!mapInstanceRef.current) {
        mapInstanceRef.current = new window.google.maps.Map(mapDiv, {
            zoom: 14,
            center: bounds.getCenter(),
            mapTypeId: window.google.maps.MapTypeId.ROADMAP,
        });
      } else {
        mapInstanceRef.current.setCenter(bounds.getCenter());
      }
      
      const currentMapInstance = mapInstanceRef.current;

      locations.forEach((loc, index) => {
        if (!loc.latitude || !loc.longitude) return;
        const locationDataWithIndex = { ...loc, originalIndex: index };
        const position = new window.google.maps.LatLng(parseFloat(loc.latitude), parseFloat(loc.longitude));

        // Always use CustomMarkerOverlay, style differently if no image
        const customMarker = new CustomMarkerOverlay(position, locationDataWithIndex, currentMapInstance);
        markersRef.current.push(customMarker);
      });

      if (!bounds.isEmpty()) {
        currentMapInstance.fitBounds(bounds);
        const listener = window.google.maps.event.addListenerOnce(currentMapInstance, "idle", () => {
            if (currentMapInstance.getZoom() > 16) {
                currentMapInstance.setZoom(16);
            }
        });
      } else if (locations.length > 0 && locations[0].latitude && locations[0].longitude) {
        // Fallback if bounds are empty but there's at least one location
        currentMapInstance.setCenter(new window.google.maps.LatLng(parseFloat(locations[0].latitude), parseFloat(locations[0].longitude)));
        currentMapInstance.setZoom(14); 
      }

    } catch (error) {
      console.error("Error initializing map:", error);
    }
  }, [isScriptLoaded, locations]);

  useEffect(() => {
    initMap();
  }, [initMap]); // initMap is now memoized with useCallback
  
  // Cleanup markers on component unmount
  useEffect(() => {
    return () => {
        markersRef.current.forEach(marker => {
            if (marker.setMap) marker.setMap(null); // For google.maps.Marker (though we are not using it now)
            else if (marker.onRemove) marker.onRemove(); // For OverlayView
        });
        markersRef.current = [];
        // Optional: Clean up Google Maps event listeners from infoWindow if necessary, though re-adding is handled.
    };
  }, []);

  const defaultMapStyle = { width: '100%', height: '450px' };

  return <div ref={mapRef} id="google-map-component-container" style={{...defaultMapStyle, ...mapContainerStyle}}></div>;
};

export default GoogleMapDisplay;